<template>
  <div class="content_retix catalogue-materiel">
    <div class="container-retix">
      <div class="catalogue-entete">
        <div>
          <h1 class="page-titre">Catalogue du matériel</h1>
          <p class="page-sous-titre">
            Prix d'achat HT et marges utilisés pour chiffrer les études au matériel.
            <span v-if="version">Version n° {{ version }}.</span>
            <span v-if="lecture" class="consultation"> Consultation seule : modifiable par les administrateurs.</span>
          </p>
        </div>
        <!-- export / import Excel (03/11/2026) : une feuille par tableau ; l'import remplit la page, à vérifier puis enregistrer -->
        <div v-if="contenu" class="actions-excel">
          <button type="button" class="btn-ligne" :disabled="excelEnCours" @click="exporterExcel">Exporter en Excel</button>
          <label v-if="!lecture" class="btn-ligne btn-import-excel" :class="{ desactive: excelEnCours }">
            Importer un fichier Excel
            <input type="file" accept=".xlsx" class="fichier-excel" :disabled="excelEnCours" @change="importerExcel" />
          </label>
        </div>
      </div>

      <p v-if="chargement" class="catalogue-note">Chargement du catalogue…</p>
      <p v-else-if="erreurChargement" class="catalogue-erreur">{{ erreurChargement }}</p>

      <template v-else-if="contenu">
        <div class="onglets" role="tablist">
          <button v-for="o in onglets" :key="o.cle" type="button" class="onglet" :class="{ 'onglet--actif': onglet === o.cle }"
            :data-onglet="o.cle" @click="onglet = o.cle">{{ o.titre }}<span v-if="nbOnglet(o.cle)" class="badge-verifier">{{ nbOnglet(o.cle) }}</span></button>
        </div>
        <p v-if="nbTotal && !lecture" class="legende-verifier">
          <span class="case-exemple"></span>
          {{ nbTotal }} valeur{{ nbTotal > 1 ? 's' : '' }} temporaire{{ nbTotal > 1 ? 's' : '' }} ou douteuse{{ nbTotal > 1 ? 's' : '' }} à vérifier.
          Corrigez la case, ou cliquez sur ✓ si la valeur est bonne ; enregistrez ensuite.
        </p>

        <div ref="ongletActif" class="catalogue-onglet">
        <!-- ===== PARTICULIER ===== -->
        <!-- key : chaque onglet a ses propres sections (sinon Vue les réutilise et une section enroulée l'est dans les deux) -->
        <div v-if="onglet === 'particulier'" key="particulier" class="bloc_content">
          <section-catalogue :a-verifier="nb(contenu.particulier.panneaux)" titre="Panneaux" sous-titre="Cochez « TVA 5,5 » pour un panneau qui permet la TVA réduite (installations jusqu'à 9 kWc). Prix d'achat et ratio liés : modifiez l'un ou l'autre. Œil barré : masqué dans les études.">
            <table-catalogue :lecture="lecture" :lignes="contenu.particulier.panneaux" :colonnes="colPanneaux" :modele="nouveauPanneau()" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.particulier.integrations)" titre="Systèmes d'intégration" sous-titre="Prix d'achat en c€/Wc. Typologies de toiture : celles où le système se pose. Carport : panneaux du carport et leur nombre.">
            <table-catalogue :lecture="lecture" :lignes="contenu.particulier.integrations" :colonnes="colFixations(contenu.particulier, true)" :modele="nouvelleFixation(true)" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(onduleurs(contenu.particulier, true))" titre="Onduleurs hybrides" sous-titre="RETIX choisit le modèle selon la puissance du projet.">
            <table-catalogue :lecture="lecture" :lignes="contenu.particulier.onduleurs" :filtre="o => !!o.hybride === true" :colonnes="colOnduleursHybrides" :modele="nouvelOnduleur('mono', 'HUAWEI', true)" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.particulier.bornes || [])" titre="Bornes de charge" sous-titre="Proposées en option à l'étape 4 (modèle et nombre) ; section « CAPEX Bornes de charge » du rapport.">
<p v-if="!bornes(contenu.particulier).length" class="a-completer">Aucune borne de charge : à compléter (+ Ajouter).</p>
            <table-catalogue :lecture="lecture" :lignes="bornes(contenu.particulier)" :colonnes="colBornes" :modele="{ marque: '', ref: '', prix: null }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.particulier.batteries)" titre="Batteries">
            <table-catalogue :lecture="lecture" :lignes="contenu.particulier.batteries" :colonnes="colBatteriesPart" :modele="{ marque: 'HUAWEI', ref: '', prix: null, kwh: null, chargeKw: null, dechargeKw: null }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue replie titre="Règles batterie ↔ onduleur" sous-titre="Règles des fiches des fabricants, appliquées par RETIX pour chaque scénario.">
            <div class="regles">
              <h3>Huawei LUNA2000 avec les onduleurs SUN2000</h3>
              <ul>
                <li>Deux batteries LUNA2000 au plus par onduleur (5 à 30 kWh) ; leurs puissances s'additionnent, limitées par la charge et la décharge max des batteries de l'onduleur.</li>
              </ul>
            </div>
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.particulier.optimiseurs)" titre="Optimiseurs" sous-titre="Prix d'achat par panneau équipé. RETIX retient le premier modèle proposé.">
            <table-catalogue :lecture="lecture" :lignes="contenu.particulier.optimiseurs" :colonnes="colOptimiseur" :modele="{ marque: '', ref: '', prixParPanneau: null }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.particulier.backups)" titre="Backup" sous-titre="Proposé en option avec une batterie. RETIX retient le premier modèle proposé pour le raccordement du client.">
            <table-catalogue :lecture="lecture" :lignes="contenu.particulier.backups" :colonnes="colBackupPart" :modele="{ marque: '', ref: '', prix: null, raccordement: 'mono' }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.particulier.electricite)" titre="Matériel électrique" sous-titre="Prix d'achat en fonction des kWc installés. Laisser « Jusqu'à » vide pour la dernière ligne.">
            <table-catalogue :lecture="lecture" :lignes="contenu.particulier.electricite" :colonnes="colPrixWc" :modele="{ kwcMax: null, eurParWc: null }" @modifie="modifie" />
          </section-catalogue>
        </div>

        <!-- ===== PROFESSIONNEL ===== -->
        <div v-if="onglet === 'pro'" key="pro" class="bloc_content">
          <section-catalogue :a-verifier="nb(contenu.pro.panneaux)" titre="Panneaux" sous-titre="Prix d'achat et ratio liés : modifiez l'un ou l'autre. Œil barré : masqué dans les études.">
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.panneaux" :colonnes="colPanneaux" :modele="nouveauPanneau()" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.pro.integrations)" titre="Systèmes d'intégration" sous-titre="Prix d'achat en c€/Wc. Typologies de toiture : celles où le système se pose. Filet sous toiture : pose FIBROSOLAR, filets en prestation externe.">
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.integrations" :colonnes="colFixations(contenu.pro, false)" :modele="nouvelleFixation(false)" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(onduleurs(contenu.pro, false))" titre="Onduleurs réseau" sous-titre="RETIX choisit le modèle selon la puissance du projet et la marque choisie par le commercial.">
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.onduleurs" :filtre="o => !!o.hybride === false" :colonnes="colOnduleursPro" :modele="nouvelOnduleur('tri', 'FOX ESS', false)" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(onduleurs(contenu.pro, true))" titre="Onduleurs hybrides" sous-titre="Utilisés avec une batterie de la même marque. RETIX choisit le modèle selon la puissance du projet.">
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.onduleurs" :filtre="o => !!o.hybride === true" :colonnes="colOnduleursHybridesPro" :modele="nouvelOnduleur('tri', 'FOX ESS', true)" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.pro.kits)" v-if="contenu.pro.kits" titre="Kits Onduleurs hybrides + Batteries" sous-titre="Onduleur hybride et batterie vendus ensemble ; les panneaux se branchent sur l'onduleur du kit. Ratios calculés sur le prix du kit complet. Conso de veille : refroidissement et auxiliaires compris.">
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.kits" :colonnes="colKits" :modele="{ marque: 'FOX ESS', nom: '', prix: null, kva: null, kwh: null, chargeKw: null, dechargeKw: null, veilleW: null }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(batteriesPro)" titre="Batteries" sous-titre="CQ7 : prix et puissances par module. PowerKeeper : par bloc. Powerstack : par unité.">
            <table-catalogue :lecture="lecture" :lignes="batteriesPro" :colonnes="colBatteriesPro" fixe @modifie="modifie" />
            <p class="avertissement">* CQ7 : ratio calculé sur le prix d'un module esclave ; il manque le prix du module maître (un par tour de modules) pour obtenir le ratio exact d'une batterie.</p>
            <p class="avertissement">* PowerKeeper : ratio calculé sur le prix d'un bloc ; il manque le prix de l'accessoire « Master » (un par batterie) et des accessoires « Slave » (un par pile en plus de la première) pour obtenir le ratio exact d'une batterie.</p>
          </section-catalogue>
          <!-- règles des fabricants (30/10/2026) : expliquées pour être validées par l'administrateur du catalogue -->
          <section-catalogue replie titre="Règles batterie ↔ onduleur" sous-titre="Règles des fiches des fabricants, appliquées par RETIX pour chaque scénario. Les valeurs se modifient ici ; les entrées batterie et la tension minimale de chaque onduleur sont dans « Onduleurs hybrides ».">
            <div class="regles">
              <template v-if="contenu.pro.batteriesCq7">
                <h3>FOX ESS CQ7 avec les onduleurs P3-Pro et P3-Plus</h3>
                <ul>
                  <li>Les modules CQ7 se montent en tours de {{ cq7.modulesParTour }} modules au plus ; chaque tour se branche sur une entrée batterie d'un onduleur (P3-Pro : 2 entrées, P3-Plus : 3).</li>
                  <li>S'il manque des entrées, RETIX ajoute des onduleurs hybrides.</li>
                  <li>Les modules sont répartis entre les tours ; la plus petite tour doit atteindre la tension minimale de l'onduleur ({{ nombreFr(cq7.tensionModuleV, 1) }} V par module).</li>
                  <li>{{ cq7.modulesMax }} modules au plus, soit {{ nombreFr(cq7.modulesMax * cq7.kwhParModule, 1) }} kWh.</li>
                </ul>
                <table-catalogue :lecture="lecture" :lignes="[cq7]" :colonnes="colRegleCq7" vertical @modifie="modifie" />
              </template>
              <template v-if="pk">
                <h3>Sungrow PowerKeeper avec les onduleurs SH</h3>
                <ul>
                  <li>Seulement les configurations types de la fiche Sungrow (tableau ci-dessous) : de 4 blocs (1 pile) à 20 blocs (4 piles de 5), soit 250 kWh au plus. Au-delà, RETIX passe au Powerstack.</li>
                  <li>Les piles sont reliées en série ; la tension ({{ nombreFr(pk.tensionBlocV, 1) }} V par bloc) doit atteindre la tension minimale de l'onduleur : 8 blocs au moins sur un SH125CX.</li>
                  <li>Prix : les blocs, l'accessoire « Master » (indispensable) et un accessoire « Slave » par pile en plus.</li>
                </ul>
                <table-catalogue :lecture="lecture" :lignes="pk.configurations" :colonnes="colConfigPowerKeeper" :modele="{ blocs: null, piles: null }" @modifie="modifie" />
                <table-catalogue :lecture="lecture" :lignes="[pk]" :colonnes="[{ cle: 'tensionBlocV', titre: 'Tension par bloc', unite: 'V', type: 'nombre' }]" vertical @modifie="modifie" />
              </template>
              <template v-if="contenu.pro.powerstack">
                <h3>Sungrow Powerstack</h3>
                <ul>
                  <li>Une unité par onduleur {{ contenu.pro.powerstack.onduleur }} ; s'il en manque, RETIX en ajoute.</li>
                  <li>{{ contenu.pro.powerstack.unitesMax }} unités au plus, soit {{ nombreFr(contenu.pro.powerstack.unitesMax * contenu.pro.powerstack.kwh, 0) }} kWh.</li>
                </ul>
                <table-catalogue :lecture="lecture" :lignes="[contenu.pro.powerstack]" :colonnes="colReglePowerstack" vertical @modifie="modifie" />
              </template>
              <template v-if="contenu.pro.kits && contenu.pro.kits.length">
                <h3>Kits Onduleurs hybrides + Batteries</h3>
                <ul>
                  <li>Jusqu'à {{ contenu.pro.kitsMax }} kits en parallèle, soit {{ nombreFr(contenu.pro.kitsMax * kwhKitMax, 0) }} kWh.</li>
                </ul>
                <table-catalogue :lecture="lecture" :lignes="[contenu.pro]" :colonnes="[{ cle: 'kitsMax', titre: 'Nombre maximum de kits', type: 'nombre' }]" vertical @modifie="modifie" />
              </template>
            </div>
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.pro.backups)" titre="Backup" sous-titre="Les articles proposés s'additionnent dans le chiffrage. Câble de la longueur du câble onduleur ↔ TGBT (le backup est au TGBT), section de l'abaque pour la plus forte puissance.">
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.backups" :colonnes="colBackupPro" :modele="{ marque: '', ref: '', prix: null, kva: null }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(shelter())" titre="Shelter" sous-titre="Option de l'étape 4 : RETIX retient le plus petit modèle proposé pour le nombre d'onduleurs du projet (nombre maximum compris ; vide : sans limite). Marge de l'installation PV.">
            <table-catalogue :lecture="lecture" :lignes="shelter()" :colonnes="colShelter" :modele="{ marque: '', ref: '', prix: null, onduleursMax: null }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.pro.bornes || [])" titre="Bornes de charge" sous-titre="Proposées en option à l'étape 4 (modèle et nombre) ; section « CAPEX Bornes de charge » du rapport.">
<p v-if="!bornes(contenu.pro).length" class="a-completer">Aucune borne de charge : à compléter (+ Ajouter).</p>
            <table-catalogue :lecture="lecture" :lignes="bornes(contenu.pro)" :colonnes="colBornes" :modele="{ marque: '', ref: '', prix: null }" @modifie="modifie" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.pro.datalogger || [])" v-if="contenu.pro.datalogger" titre="Datalogger" sous-titre="Prix de vente HT en fonction de la puissance d'abonnement du client ; le commercial peut le modifier dans l'étude. Laisser « Jusqu'à » vide pour la dernière ligne.">
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.datalogger" :colonnes="colDatalogger" :modele="{ kvaMax: null, prix: null }" @modifie="modifie" />
          </section-catalogue>
          <!-- un seul prix, quelle que soit la typologie (03/11/2026) -->
          <section-catalogue :a-verifier="nbMaterielElec" titre="Matériel électrique" sous-titre="Prix d'achat en fonction des kWc installés, quelle que soit la typologie (tranches communes avec les jours de travail des toitures, onglet Main d'œuvre). Laisser « Jusqu'à » vide pour la dernière ligne.">
            <table-catalogue v-if="plates.tranches" :lecture="lecture" :lignes="plates.tranches" :colonnes="colMaterielElec" fixe @modifie="modifieTypologie('tranches')" />
          </section-catalogue>
          <section-catalogue :a-verifier="nb(contenu.pro.cables.concat(contenu.pro.abaqueCable || []))" v-if="contenu.pro.cables" titre="Câble Onduleur ↔ TGBT" sous-titre="Prix d'achat au mètre. RETIX prend la section de l'abaque (en aluminium) dans le pire cas : ligne de la puissance des onduleurs juste au-dessus (15 kVA → ligne 20 kVA), colonne de la longueur juste au-dessus ; sans ce câble au catalogue, la section au-dessus.">
            <h3>Standard</h3>
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.cables" :filtre="c => c.categorie !== 'erp'" :colonnes="colCables" :modele="{ ref: '', prix: null, categorie: 'standard', ame: 'alu', section: null, phase: 'tri' }" @modifie="modifie" />
            <h3>ERP (établissement recevant du public)</h3>
            <table-catalogue :lecture="lecture" :lignes="contenu.pro.cables" :filtre="c => c.categorie === 'erp'" :colonnes="colCables" :modele="{ ref: '', prix: null, categorie: 'erp', ame: 'alu', section: null, phase: 'tri' }" @modifie="modifie" />
            <h3>Abaque des sections (mm², câble aluminium) selon la puissance des onduleurs et la longueur</h3>
            <table-catalogue :lecture="lecture" v-if="contenu.pro.abaqueCable" :lignes="contenu.pro.abaqueCable" :colonnes="colAbaque" fixe @modifie="modifie" />
          </section-catalogue>
        </div>

        <!-- ===== MARGES (03/11/2026) ===== -->
        <div v-if="onglet === 'marges'" key="marges" class="bloc_content">
          <template v-if="contenu.marges">
            <section-catalogue v-for="t in tableauxMarges" :key="t.titre" :a-verifier="nb(t.lignes)" :titre="t.titre" sous-titre="Marges minimales en fonction des kWc installés. Laisser « Jusqu'à » vide pour la dernière ligne.">
              <table-catalogue :lecture="lecture" :lignes="t.lignes" :colonnes="colMargesSections" :modele="{ kwcMax: null, pv: null, batterie: null, presta: null, bornes: null }" @modifie="modifie" />
            </section-catalogue>
          </template>
        </div>

        <!-- ===== PRESTATIONS EXTERNES (03/11/2026) ===== -->
        <div v-if="onglet === 'prestations'" key="prestations" class="bloc_content">
          <template v-if="contenu.pro.prestations">
            <p class="aide">Prestations sous-traitées d'un projet professionnel, avec la marge des prestations (onglet « Marges »). Prix d'achat ; vides : non chiffrés.</p>
            <section-catalogue :a-verifier="nb(contenu.pro.prestations.ombriereStructure || [])" titre="Ombrières : structure primaire" sous-titre="Toujours en prestation externe. Prix d'achat au Wc selon la puissance des ombrières.">
              <table-catalogue :lecture="lecture" :lignes="contenu.pro.prestations.ombriereStructure" :colonnes="colPrixWc" :modele="{ kwcMax: null, eurParWc: null }" @modifie="modifie" />
            </section-catalogue>
            <section-catalogue :a-verifier="nb(contenu.pro.prestations.ombrierePose || [])" titre="Ombrières : pose sous-traitée" sous-titre="Quand le commercial choisit « sous-traitées » à l'étape 4 : remplace notre main d'œuvre et nos engins de pose.">
              <table-catalogue :lecture="lecture" :lignes="contenu.pro.prestations.ombrierePose" :colonnes="colPrixWc" :modele="{ kwcMax: null, eurParWc: null }" @modifie="modifie" />
            </section-catalogue>
            <section-catalogue :a-verifier="nb(contenu.pro.prestations.filets || [])" titre="Pose de filets sous toiture" sous-titre="Pour un système d'intégration avec « Filet sous toiture » (FIBROSOLAR). Prix d'achat en fonction des kWc concernés. Laisser « Jusqu'à » vide pour la dernière ligne.">
              <table-catalogue :lecture="lecture" :lignes="contenu.pro.prestations.filets" :colonnes="colPrixWc" :modele="{ kwcMax: null, eurParWc: null }" @modifie="modifie" />
            </section-catalogue>
            <section-catalogue :a-verifier="nb(contenu.pro.prestations.bacAcier || [])" titre="Pose de bac acier" sous-titre="Fourniture et pose, option de l'étape 4 avec la surface. Prix d'achat en fonction de la surface. Laisser « Jusqu'à » vide pour la dernière ligne.">
              <table-catalogue :lecture="lecture" :lignes="contenu.pro.prestations.bacAcier" :colonnes="colPrixM2" :modele="{ m2Max: null, eurParM2: null }" @modifie="modifie" />
            </section-catalogue>
          </template>
          <p v-else class="catalogue-note">Prestations absentes de ce catalogue.</p>
        </div>

        <!-- ===== MAIN D'ŒUVRE (30/10/2026 ; refait le 03/11/2026 : un même format de tableau partout) ===== -->
        <div v-if="onglet === 'mainOeuvre'" key="mainOeuvre" class="bloc_content">
          <section-catalogue :a-verifier="nb(contenu.equipes || [])" v-if="contenu.equipes" titre="Équipes" sous-titre="Tarifs par personne, sans marge ; un chantier de n jours compte n journées et n − 1 nuits pour chaque personne.">
            <table-catalogue :lecture="lecture" :lignes="contenu.equipes" :colonnes="colTarifs" fixe @modifie="modifie" />
          </section-catalogue>
          <!-- temps de travail (04/11/2026) : un tableau par nature de travaux, une ligne par client et par puissance -->
          <section-catalogue v-for="t in tableauxJours" :key="t.cle" :a-verifier="nb(t.lignes)" :titre="t.titre" :sous-titre="t.aide">
            <table-catalogue :lecture="lecture" :lignes="t.lignes" :colonnes="colJoursClient" :modele="{ client: 'agri', kwcMax: null, toiture: null, sol: null, ombriere: null, carport: null }" @modifie="modifie" />
          </section-catalogue>
          <template v-if="contenu.engins">
            <section-catalogue :a-verifier="nb([contenu.engins])" titre="Prix des engins" sous-titre="Prix d'un jour de location, sans marge.">
              <table-catalogue :lecture="lecture" :lignes="[contenu.engins]" :colonnes="colPrixEngins" vertical en-ligne @modifie="modifie" />
            </section-catalogue>
            <section-catalogue v-for="t in tableauxEngins" :key="t.cle" :a-verifier="nb(t.lignes)" :titre="t.titre">
              <table-catalogue :lecture="lecture" :lignes="t.lignes" :colonnes="colEnginsClient(t.groupe)" fixe @modifie="modifie" />
            </section-catalogue>
          </template>
        </div>

        <!-- ===== OPEX (30/10/2026) ===== -->
        <div v-if="onglet === 'opex'" key="opex" class="bloc_content">
          <!-- maintenance et assurance côte à côte, format « Jusqu'à » pour tous (04/11/2026) -->
          <section-catalogue :a-verifier="nb((contenu.particulier.maintenance || []).concat(contenu.particulier.assurance || []))" titre="Maintenance et assurance Particulier" sous-titre="Montants en fonction des kWc installés. Laisser « Jusqu'à » vide pour la dernière ligne.">
            <div class="cote-a-cote">
              <div v-if="contenu.particulier.maintenance">
                <h3>Maintenance (déplacement compris)</h3>
                <table-catalogue :lecture="lecture" :lignes="contenu.particulier.maintenance" :colonnes="colForfait('Maintenance')" :modele="{ kwcMax: null, montant: null }" @modifie="modifie" />
              </div>
              <div v-if="contenu.particulier.assurance">
                <h3>Assurance</h3>
                <table-catalogue :lecture="lecture" :lignes="contenu.particulier.assurance" :colonnes="colForfait('Assurance')" :modele="{ kwcMax: null, montant: null }" @modifie="modifie" />
              </div>
            </div>
          </section-catalogue>
          <section-catalogue :a-verifier="nb((contenu.pro.maintenance || []).concat(contenu.pro.assurance || []))" titre="Maintenance et assurance Professionnel" sous-titre="Montants en fonction des kWc installés. Laisser « Jusqu'à » vide pour la dernière ligne.">
            <div class="cote-a-cote">
              <div v-if="contenu.pro.maintenance">
                <h3>Maintenance (déplacement compris)</h3>
                <table-catalogue :lecture="lecture" :lignes="contenu.pro.maintenance" :colonnes="colMaintenance" :modele="{ kwcMax: null, agri: null, ict: null }" @modifie="modifie" />
              </div>
              <div v-if="contenu.pro.assurance">
                <h3>Assurance</h3>
                <table-catalogue :lecture="lecture" :lignes="contenu.pro.assurance" :colonnes="colAssurancePro" :modele="{ kwcMax: null, montant: null }" @modifie="modifie" />
              </div>
            </div>
          </section-catalogue>
        </div>

        <!-- ===== HYPOTHÈSES ===== -->
        <div v-if="onglet === 'general'" key="general" class="bloc_content">
          <section-catalogue v-if="contenu.limites" titre="Limites de puissance des études">
            <table-catalogue :lecture="lecture" :lignes="[contenu.limites]" :colonnes="colLimitesPuissance" vertical @modifie="modifie" />
          </section-catalogue>
          <!-- valeurs par défaut des nouvelles études reprises par thème (02/11/2026) ; les autres restent dans le catalogue, non affichées -->
          <section-catalogue :a-verifier="nb([contenu.ratios])" titre="Hypothèses de calcul">
            <template v-if="contenu.ratios">
              <h3>Ratio panneaux / onduleur</h3>
              <p class="aide">Ratio des kWc installables en fonction des kVA de l'onduleur. Le commercial peut ajuster ce ratio dans son étude. Au-delà du max, un message l'invite à faire valider son ratio par le BE.</p>
              <table-catalogue :lecture="lecture" :lignes="ratiosPlats" :colonnes="colRatios" fixe @modifie="modifieRatios" />
            </template>
            <template v-if="contenu.defautsEtudes">
              <div v-for="g in groupesDefauts" :key="g.groupe">
                <h3>{{ g.groupe }}</h3>
                <table-catalogue :lecture="lecture" :lignes="g.lignes" :colonnes="colDefauts" fixe @modifie="modifieDefauts" />
              </div>
              <h3>OPEX</h3>
              <!-- hausse de la maintenance sur une ligne : « x % tous les y ans » -->
              <p class="ligne-maintenance" :class="{ modifiee: maintenanceModifiee }">
                Hausse de la maintenance :
                <input type="number" step="0.1" min="0" data-cle="hausseMaintenancePct" :value="contenu.defautsEtudes.hausseMaintenancePct" @input="ecrireDefaut('hausseMaintenancePct', $event.target.value)" />
                % tous les
                <input type="number" step="1" min="1" data-cle="hausseMaintenancePeriode" :value="contenu.defautsEtudes.hausseMaintenancePeriode" @input="ecrireDefaut('hausseMaintenancePeriode', $event.target.value)" />
                ans
              </p>
              <table-catalogue :lecture="lecture" :lignes="ligneAssurance" :colonnes="colDefauts" fixe @modifie="modifieDefauts" />
            </template>
          </section-catalogue>
        </div>

        <!-- ===== HISTORIQUE ===== -->
        <div v-if="onglet === 'historique'" key="historique" class="bloc_content">
          <table class="historique">
            <thead><tr><th>Version</th><th>Date</th><th>Auteur</th><th>Commentaire</th><th></th></tr></thead>
            <tbody>
              <template v-for="(v, i) in historique">
                <tr :key="v.id" :data-version="v.id">
                  <td>n° {{ v.id }}<span v-if="v.id === version" class="badge-active">active</span></td>
                  <td>{{ dateFr(v.creeLe) }}</td>
                  <td>{{ v.auteur || '—' }}</td>
                  <td>{{ v.commentaire }}</td>
                  <td class="historique-actions">
                    <!-- changements par rapport à la version précédente (30/10/2026) -->
                    <button v-if="historique[i + 1]" type="button" class="btn-ligne btn-changements" @click="basculerChangements(v, historique[i + 1])">
                      {{ changements[v.id] && changements[v.id].ouvert ? 'Masquer les changements' : 'Voir les changements' }}
                    </button>
                    <button v-if="v.id !== version && !lecture" type="button" class="btn-ligne" @click="restaurer(v)">Rétablir</button>
                  </td>
                </tr>
                <tr v-if="changements[v.id] && changements[v.id].ouvert" :key="v.id + '-changements'" class="changements">
                  <td colspan="5">
                    <p v-if="changements[v.id].chargement" class="catalogue-note">Comparaison avec la version n° {{ historique[i + 1].id }}…</p>
                    <p v-else-if="!changements[v.id].lignes.length" class="catalogue-note">Aucun changement par rapport à la version n° {{ historique[i + 1].id }}.</p>
                    <template v-else>
                      <p class="changements-titre">{{ changements[v.id].lignes.length }} changement{{ changements[v.id].lignes.length > 1 ? 's' : '' }} par rapport à la version n° {{ historique[i + 1].id }}</p>
                      <ul><li v-for="(c, j) in changements[v.id].lignes.slice(0, changements[v.id].tout ? undefined : 40)" :key="j">{{ c }}</li></ul>
                      <button v-if="changements[v.id].lignes.length > 40 && !changements[v.id].tout" type="button" class="btn-ligne" @click="changements[v.id].tout = true">
                        Voir les {{ changements[v.id].lignes.length - 40 }} autres
                      </button>
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        </div>

        <!-- barre d'enregistrement -->
        <div v-if="onglet !== 'historique' && !lecture" class="barre-enregistrement">
          <ul v-if="erreurs.length" class="catalogue-erreurs">
            <li v-for="(e, i) in erreurs" :key="i">{{ e }}</li>
          </ul>
          <p v-if="compteRenduExcel" class="compte-rendu-excel">{{ compteRenduExcel }}</p>
          <!-- saisies invalides signalées dans les cases (03/11/2026) : enregistrement bloqué -->
          <p v-if="erreursSaisie.length" class="catalogue-erreurs saisies-invalides">
            {{ erreursSaisie.length }} saisie{{ erreursSaisie.length > 1 ? 's' : '' }} à corriger (cases en rouge) : {{ erreursSaisie.slice(0, 3).join(' ; ') }}{{ erreursSaisie.length > 3 ? '…' : '' }}
          </p>
          <!-- changements avant d'enregistrer (03/11/2026) -->
          <div v-if="changementsEnCours.length" class="changements-en-cours">
            <span class="changements-en-cours__titre">{{ changementsEnCours.length }} changement{{ changementsEnCours.length > 1 ? 's' : '' }} à enregistrer :</span>
            <ul><li v-for="(c, i) in changementsEnCours.slice(0, tousLesChangements ? undefined : 6)" :key="i">{{ c }}</li></ul>
            <button v-if="changementsEnCours.length > 6" type="button" class="lien" @click="tousLesChangements = !tousLesChangements">
              {{ tousLesChangements ? 'Réduire' : 'Voir les ' + (changementsEnCours.length - 6) + ' autres' }}
            </button>
          </div>
          <div class="barre-ligne">
            <input v-model="commentaire" type="text" class="commentaire" maxlength="500" placeholder="Commentaire (ex. nouveaux prix FOX ESS d'octobre)" aria-label="Commentaire" />
            <button type="button" class="btn-ligne" :disabled="!estModifie || enregistrement" @click="annuler">Annuler les modifications</button>
            <button type="button" class="btn-jaune" :disabled="!estModifie || enregistrement || erreursSaisie.length > 0" @click="enregistrer">
              {{ enregistrement ? 'Enregistrement…' : 'Enregistrer' }}
            </button>
          </div>
          <p class="aide">Les nouvelles études et les recalculs utilisent aussitôt la version enregistrée.</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { authenticationService } from '@/services/authentication'
import { conf } from '@/config/config'
import TableCatalogue from '@/components/TableCatalogue.vue'
import SectionCatalogue from '@/components/SectionCatalogue.vue'
import { PARAMETRES_ETUDE } from '@/utils/defautsEtude'
import { nombreFr } from '@/utils/format'
import { changementsCatalogue, erreursCatalogue } from '@/utils/diffCatalogue'
import { exporterCatalogue, importerCatalogue } from '@/utils/catalogueExcel'

// valeurs au chargement, non enregistrées (propriété non énumérable) : cases modifiées en bleu (30/10/2026)
function marquerOrigine(x) {
  if (Array.isArray(x)) { x.forEach(marquerOrigine); return }
  if (!x || typeof x !== 'object') return
  const orig = {}
  Object.keys(x).forEach(k => {
    const v = x[k]
    if (v === null || typeof v !== 'object') orig[k] = v
    else marquerOrigine(v)
  })
  Object.defineProperty(x, '__orig', { value: orig, enumerable: false, configurable: true, writable: true })
}

// fabricant en majuscules ; modèle tel qu'écrit (29/10/2026)
// fabricant choisi dans une liste (ceux de la section), « Nouveau fabricant… » pour en ajouter un
const FABRICANT = { cle: 'marque', titre: 'Fabricant', type: 'fabricant' }
const MODELE = { cle: 'ref', titre: 'Modèle', largeur: '260px' }
const PRIX = { cle: 'prix', titre: "Prix d'achat", unite: '€', type: 'nombre' }
// matériel proposé dans les études (03/11/2026) : décoché = masqué
const VISIBLE = { cle: 'visible', titre: '', type: 'visible' } // première colonne, œil cliquable (03/11/2026)
// typologies où un système d'intégration se pose (03/11/2026)
const TYPOLOGIES_PART = [{ valeur: 'inclinee', libelle: 'inclinée' }, { valeur: 'terrasse', libelle: 'terrasse' }, { valeur: 'bipv', libelle: 'BIPV' }, { valeur: 'sol', libelle: 'sol' }, { valeur: 'carport', libelle: 'carport' }]
const TYPOLOGIES_PRO = [{ valeur: 'inclinee', libelle: 'inclinée' }, { valeur: 'terrasse', libelle: 'terrasse' }, { valeur: 'bipv', libelle: 'BIPV' }, { valeur: 'sol', libelle: 'sol' }, { valeur: 'ombriere', libelle: 'ombrière' }]
// prix d'achat par kWh, pour information (30/10/2026) ; CQ7 : prix d'un module esclave
// avec maître / esclave (CQ7, PowerKeeper) : « * », avertissement sous le tableau
const RATIO_BATTERIE = {
  cle: '_eurParKwh', titre: 'Ratio', unite: '€/kWh', type: 'calcule', decimales: 0,
  renvoi: l => (l.prixMaitre != null ? '*' : ''),
  valeur: l => {
    const prix = [l.prix, l.prixBloc, l.prixEsclave].find(x => x != null)
    const kwh = [l.kwh, l.kwhParBloc, l.kwhParModule].find(x => x != null)
    return kwh > 0 && prix != null ? prix / kwh : null // €/kWh (03/11/2026)
  },
}
// valeurs par défaut des nouvelles études montrées dans « Hypothèses de calcul » (02/11/2026)
const DEFAUTS_AFFICHES = [
  { groupe: 'Batterie', cles: ['rendementBatterie', 'rendementConversionBatterie', 'capaciteUtilisableBatterie'] },
  { groupe: 'Projections', cles: ['inflationElec', 'degradationPanneaux', 'degradationBatterie'] },
  { groupe: 'Rachat du surplus', cles: ['rachatSurplusUnitaire'] },
]
// formule Excel d'un ratio (04/11/2026) : prix ÷ grandeur × facteur, vide tant qu'il manque une valeur
function ratioExcel(prix, grandeur, facteur, decimales) {
  return 'IF(AND(ISNUMBER(' + prix + '),ISNUMBER(' + grandeur + '),N(' + grandeur + ')>0),ROUND(' + prix + '/' + grandeur + '*' + facteur + ',' + decimales + '),"")'
}
// types de client des tableaux de main d'œuvre et d'engins (04/11/2026)
const CLIENTS = [{ valeur: 'particulier', libelle: 'Particulier' }, { valeur: 'agri', libelle: 'Agricole' }, { valeur: 'ict', libelle: 'ICT' }]
// ombrière : professionnels seulement ; carport : particulier seulement (cases grisées, 04/11/2026)
const OMBRIERE_SANS_OBJET = l => l.client === 'particulier'
const CARPORT_SANS_OBJET = l => l.client !== 'particulier'
const AMES = [{ valeur: 'cuivre', libelle: 'Cu' }, { valeur: 'alu', libelle: 'Alu' }]

// nombre de valeurs à vérifier (« aVerifier » des articles) dans une partie du catalogue
function compter(x) {
  if (Array.isArray(x)) return x.reduce((n, y) => n + compter(y), 0)
  if (!x || typeof x !== 'object') return 0
  return Object.keys(x).reduce((n, k) => n + (k === 'aVerifier' ? (Array.isArray(x[k]) ? x[k].length : 0) : compter(x[k])), 0)
}

function entetes() {
  return { headers: { Authorization: 'Bearer ' + authenticationService.status.jwtToken } }
}

export default {
  name: 'CatalogueMateriel',
  components: { TableCatalogue, SectionCatalogue },
  data() {
    return {
      PRIX,
      chargement: true,
      erreurChargement: '',
      version: null,
      contenu: null,
      original: '',
      onglet: 'particulier',
      onglets: [
        { cle: 'particulier', titre: 'CAPEX Particulier' },
        { cle: 'pro', titre: 'CAPEX Professionnel' },
        { cle: 'marges', titre: 'Marges' },
        { cle: 'prestations', titre: 'Prestations' },
        { cle: 'mainOeuvre', titre: "Main d'œuvre" },
        { cle: 'opex', titre: 'OPEX' },
        { cle: 'general', titre: 'Hypothèses' },
        { cle: 'historique', titre: 'Historique' },
      ],
      historique: [],
      commentaire: '',
      erreurs: [],
      enregistrement: false,
      revision: 0, // force le recalcul de estModifie (le contenu est modifié sur place)
      tranchesPlates: [],
      plates: {}, // tranches de main d'œuvre au sol et en ombrière (03/11/2026), à plat comme tranchesPlates
      excelEnCours: false,
      compteRenduExcel: '',
      tousLesChangements: false,
      ratiosPlats: [], // ratios panneaux / onduleur : une ligne par type d'onduleur, défaut et max
      groupesDefauts: [], // valeurs par défaut des nouvelles études, par thème (30/10/2026)
      ligneAssurance: [], // inflation de l'assurance, sous la hausse de la maintenance (02/11/2026)
      changements: {}, // historique : changements de chaque version, chargés à la demande
    }
  },
  computed: {
    // catalogue consultable par tous, modifiable par les administrateurs (03/11/2026)
    lecture() { return !authenticationService.isAdmin() },
    // changements par rapport à la version enregistrée, en clair (03/11/2026)
    changementsEnCours() {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      if (!this.estModifie) return []
      try { return changementsCatalogue(this.nettoye(JSON.parse(this.original)), this.nettoye(this.contenu)) } catch (e) { return [] }
    },
    // saisies invalides (03/11/2026) : mêmes règles que les cases en rouge et que le contrôle du serveur
    erreursSaisie() {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      return this.contenu ? erreursCatalogue(this.contenu) : []
    },
    estModifie() {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      return !!this.contenu && JSON.stringify(this.contenu) !== this.original
    },
    // valeurs temporaires ou douteuses à vérifier (29/10/2026)
    nbTotal() {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      return this.contenu ? compter(this.contenu) : 0
    },
    cq7() { return this.contenu.pro.batteriesCq7 },
    pk() { return this.contenu.pro.batteriesPowerKeeper },
    kwhKitMax() { return Math.max(0, ...(this.contenu.pro.kits || []).map(k => k.kwh || 0)) },
    colRegleCq7() {
      return [
        { cle: 'modulesParTour', titre: 'Modules par tour (au plus)', type: 'nombre' },
        { cle: 'modulesMax', titre: 'Modules au plus', type: 'nombre' },
        { cle: 'tensionModuleV', titre: 'Tension par module', unite: 'V', type: 'nombre' },
      ]
    },
    colConfigPowerKeeper() {
      return [
        { cle: 'blocs', titre: 'Blocs', type: 'nombre' },
        { cle: 'piles', titre: 'Piles', type: 'nombre' },
        { cle: '_kwh', titre: 'Capacité', unite: 'kWh', type: 'calcule', decimales: 1, valeur: l => (l.blocs > 0 ? l.blocs * this.pk.kwhParBloc : null) },
      ]
    },
    colReglePowerstack() {
      return [
        { cle: 'onduleur', titre: 'Onduleur (une unité par onduleur)' },
        { cle: 'unitesMax', titre: 'Unités au plus', type: 'nombre' },
      ]
    },
    batteriesPro() {
      const p = this.contenu.pro
      return [p.batteriesCq7, p.batteriesPowerKeeper, p.powerstack].filter(x => x)
    },
    // ordre des colonnes partout (29/10/2026) : fabricant, modèle, prix d'achat, marge, puis les caractéristiques
    // 03/11/2026 : prix et ratio liés, longueur × largeur, garanties, visibilité
    colPanneaux() {
      return [
        VISIBLE,
        FABRICANT,
        MODELE,
        // prix d'achat et ratio liés (03/11/2026) : même fond, regroupés sous un même titre
        { ...PRIX, titre: '€/panneau', unite: null, signalerVide: true, lie: true, groupe: "Prix d'achat" },
        // ratio : formule dans Excel (04/11/2026), le prix du panneau fait foi à l'import
        { cle: '_ratio', titre: 'c€/Wc', type: 'nombre', lie: true, groupe: "Prix d'achat", formule: (r) => ratioExcel(r('prix'), r('wc'), 100, 2), derive: {
          cle: 'prix',
          get: l => (l.wc > 0 && l.prix != null ? Math.round(l.prix / l.wc * 100 * 100) / 100 : null),
          set: (l, v, set) => set(l, 'prix', v == null || !(l.wc > 0) ? null : Math.round(v * l.wc) / 100),
        } },
        { cle: 'wc', titre: 'Puissance', unite: 'Wc', type: 'nombre', obligatoire: true },
        { cle: 'longueur', titre: 'Longueur', type: 'nombre', groupe: 'Dimensions (mm)' },
        { cle: 'largeur', titre: 'Largeur', type: 'nombre', groupe: 'Dimensions (mm)' },
        { cle: 'tva55', titre: 'TVA 5,5', type: 'case' },
        { cle: 'garantiePerformancePct', titre: '%', type: 'nombre', groupe: 'Garantie de performance' },
        { cle: 'garantiePerformanceAns', titre: 'au bout de', unite: 'ans', type: 'nombre', groupe: 'Garantie de performance' },
        { cle: 'garantieMaterielleAns', titre: 'Garantie matérielle', unite: 'ans', type: 'nombre' },
      ]
    },
    colBornes() { return [VISIBLE, FABRICANT, MODELE, { ...PRIX, signalerVide: true }] },
    colShelter() {
      return [VISIBLE, FABRICANT, MODELE, { ...PRIX, signalerVide: true }, { cle: 'onduleursMax', titre: "Nombre d'onduleurs max", type: 'nombre' }]
    },
    colPrixWc() {
      return [
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'eurParWc', titre: "Prix d'achat", unite: 'c€/Wc', type: 'nombre', echelle: 100, signalerVide: true },
      ]
    },
    colPrixM2() {
      return [
        { cle: 'm2Max', titre: "Jusqu'à", unite: 'm²', type: 'nombre' },
        { cle: 'eurParM2', titre: "Prix d'achat", unite: '€/m²', type: 'nombre', signalerVide: true },
      ]
    },
    tableauxMarges() {
      const m = this.contenu.marges || {}
      return [{ titre: 'Marges Particulier', lignes: m.particulier || [] }, { titre: 'Marges Agricole', lignes: m.agri || [] }, { titre: 'Marges ICT', lignes: m.ict || [] }]
    },
    tableauxJours() {
      const j = this.contenu.joursTravail || {}
      const aide = "Jours de travail selon le client, la puissance et la typologie. Laisser « Jusqu'à » vide pour la dernière ligne de chaque client."
      return [
        { cle: 'pose', titre: 'Temps de pose', aide: aide + ' Carport : jours de pose par carport.', lignes: j.pose || [] },
        { cle: 'travauxElectriques', titre: 'Temps des travaux électriques', aide, lignes: j.travauxElectriques || [] },
        { cle: 'batterie', titre: 'Temps des travaux de batterie', aide: "Jours liés à la batterie, en plus des travaux électriques. Laisser « Jusqu'à » vide pour la dernière ligne de chaque client.", lignes: j.batterie || [] },
      ]
    },
    tableauxEngins() {
      const e = this.contenu.engins || {}
      return [
        { cle: 'nacellesPose', titre: 'Nacelles pour la pose', groupe: 'Nombre de nacelles', lignes: e.nacellesPose || [] },
        { cle: 'nacellesElectricite', titre: 'Nacelles pour les travaux électriques', groupe: 'Nombre de nacelles', lignes: e.nacellesElectricite || [] },
        { cle: 'telescopiquesPose', titre: 'Télescopiques pour la pose', groupe: 'Nombre de télescopiques', lignes: e.telescopiquesPose || [] },
      ]
    },
    colJoursClient() {
      return [
        { cle: 'client', titre: 'Client', type: 'choix', options: CLIENTS },
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'toiture', titre: 'Toiture', type: 'nombre', groupe: 'Jours de travail' },
        { cle: 'sol', titre: 'Centrale au sol', type: 'nombre', groupe: 'Jours de travail' },
        { cle: 'ombriere', titre: 'Ombrière', type: 'nombre', groupe: 'Jours de travail', inactif: OMBRIERE_SANS_OBJET },
        { cle: 'carport', titre: 'Carport', type: 'nombre', groupe: 'Jours de travail', inactif: CARPORT_SANS_OBJET },
      ]
    },
    colPrixEngins() {
      return [
        { cle: 'nacellePrixJour', titre: 'Prix par jour : nacelle', unite: '€', type: 'nombre', signalerVide: true },
        { cle: 'telescopiquePrixJour', titre: 'télescopique', unite: '€', type: 'nombre', signalerVide: true },
      ]
    },
    colTranchesTypologie() {
      const cols = [{ cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' }]
      ;[['agri', 'Agricole'], ['ict', 'ICT']].forEach(([k, groupe]) => cols.push(
        { cle: k + '.joursPose', titre: 'Pose', unite: 'j', type: 'nombre', groupe },
        { cle: k + '.joursElectricite', titre: 'Élec sans batterie', unite: 'j', type: 'nombre', groupe },
        { cle: k + '.joursElectriciteBatterie', titre: 'Élec avec batterie', unite: 'j', type: 'nombre', groupe },
        { cle: k + '.electriciteEurParWc', titre: 'Matériel élec.', unite: 'c€/Wc', type: 'nombre', echelle: 100, groupe }))
      return cols
    },
    colOnduleurs() {
      return [
        VISIBLE,
        FABRICANT,
        MODELE,
        { ...PRIX, titre: '€', unite: null, groupe: "Prix d'achat" },
        { cle: '_eurParKva', titre: 'c€/VA', groupe: "Prix d'achat", type: 'calcule', valeur: l => (l.kva > 0 && l.prix != null ? l.prix / l.kva / 10 : null), decimales: 1, formule: r => ratioExcel(r('prix'), r('kva'), 0.1, 1) },
        { cle: 'phase', titre: 'Type', type: 'choix', options: [{ valeur: 'mono', libelle: 'mono' }, { valeur: 'tri', libelle: 'tri' }] },
        { cle: 'kva', titre: 'Puissance AC max', unite: 'kVA', type: 'nombre', obligatoire: true },
        { cle: 'veilleW', titre: 'Veille', unite: 'W', type: 'nombre' },
      ]
    },
    // extensions de garantie (03/11/2026) : 5 ans de base, prix d'achat de 10, 15 et 20 ans, sans marge
    colGaranties() {
      return [
        { cle: 'garantie10', titre: '10 ans', type: 'nombre', groupe: 'Extension de garantie (€)' },
        { cle: 'garantie15', titre: '15 ans', type: 'nombre', groupe: 'Extension de garantie (€)' },
        { cle: 'garantie20', titre: '20 ans', type: 'nombre', groupe: 'Extension de garantie (€)' },
      ]
    },
    // onduleurs hybrides (30/10/2026) : charge max des batteries branchées dessus
    colOnduleursHybrides() {
      return this.colOnduleurs.concat([
        { cle: 'batterieChargeKw', titre: 'Charge max', unite: 'kW', type: 'nombre', groupe: 'Batteries' },
        { cle: 'batterieDechargeKw', titre: 'Décharge max', unite: 'kW', type: 'nombre', groupe: 'Batteries' },
      ]).concat(this.colGaranties)
    },
    // professionnel : toujours triphasé (29/10/2026), pas de colonne « Type » (30/10/2026)
    colOnduleursPro() { return this.colOnduleurs.filter(c => c.cle !== 'phase').concat(this.colGaranties) },
    colOnduleursHybridesPro() {
      const g = this.colGaranties.map(c => c.cle)
      return this.colOnduleursHybrides.filter(c => c.cle !== 'phase' && !g.includes(c.cle)).concat([
        { cle: 'entreesBatterie', titre: 'Entrées', type: 'nombre', groupe: 'Batteries' },
        { cle: 'tensionBatterieMinV', titre: 'Tension min', unite: 'V', type: 'nombre', groupe: 'Batteries' },
      ]).concat(this.colGaranties)
    },
    colBatteriesPart() {
      return [
        VISIBLE,
        FABRICANT,
        MODELE,
        { ...PRIX, titre: '€', unite: null, groupe: "Prix d'achat" },
        { ...RATIO_BATTERIE, titre: '€/kWh', unite: null, groupe: "Prix d'achat", formule: r => ratioExcel(r('prix'), r('kwh'), 1, 0) },
        { cle: 'kwh', titre: 'Capacité', unite: 'kWh', type: 'nombre' },
        { cle: 'chargeKw', titre: 'Charge', type: 'nombre', groupe: 'Puissance max (kW)' },
        { cle: 'dechargeKw', titre: 'Décharge', type: 'nombre', groupe: 'Puissance max (kW)' },
      ]
    },
    colOptimiseur() {
      return [VISIBLE, FABRICANT, MODELE, { cle: 'prixParPanneau', titre: "Prix d'achat", unite: '€', type: 'nombre', signalerVide: true }]
    },
    colBackupPart() {
      return [VISIBLE, FABRICANT, MODELE, { ...PRIX, signalerVide: true },
        { cle: 'raccordement', titre: 'Raccordement', type: 'choix', options: [{ valeur: 'mono', libelle: 'Monophasé' }, { valeur: 'tri', libelle: 'Triphasé' }] }]
    },
    colBackupPro() {
      return [VISIBLE, FABRICANT, MODELE, { ...PRIX, signalerVide: true }, { cle: 'kva', titre: 'Puissance', unite: 'kVA', type: 'nombre' }]
    },
    // marges minimales par section (03/11/2026) ; mêmes colonnes pour tous les types de client (04/11/2026)
    colMargesSections() {
      const marge = (cle, titre) => ({ cle, titre, groupe: 'Marge minimale (%)', type: 'nombre', max: 99.99, messageMax: 'Marge de 0 à moins de 100 %' })
      return [{ cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        marge('pv', 'Installation PV'), marge('batterie', 'Batterie'), marge('bornes', 'Bornes'), marge('presta', 'Presta externe')]
    },
    // abaque des câbles (format 13) : une ligne par puissance, une colonne par longueur
    colAbaque() {
      const lignes = this.contenu.pro.abaqueCable || []
      const longueurs = lignes.length ? Object.keys(lignes[0]).filter(k => /^m\d+$/.test(k)).sort((a, b) => a.slice(1) - b.slice(1)) : []
      return [{ cle: 'kva', titre: 'Puissance des onduleurs', unite: 'kVA', type: 'nombre' }]
        .concat(longueurs.map(k => ({ cle: k, titre: k.slice(1), largeur: '58px', groupe: 'Longueur du câble (m)' })))
    },
    // en-têtes sur deux lignes comme la maintenance, à côté : lignes alignées (04/11/2026)
    colAssurancePro() {
      return [
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'montant', titre: 'Agricole et ICT', type: 'nombre', groupe: 'Assurance (€/an)' },
      ]
    },
    colMaintenance() {
      return [
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'agri', titre: 'Agricole', type: 'nombre', groupe: 'Maintenance, déplacement compris (€/an)' },
        { cle: 'ict', titre: 'ICT', type: 'nombre', groupe: 'Maintenance, déplacement compris (€/an)' },
      ]
    },
    colJoursPose() {
      return [
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'jours', titre: 'Jours', type: 'nombre' },
      ]
    },
    colTranchesElectricite() {
      return [
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'agri.electriciteEurParWc', titre: "Prix d'achat agricole", unite: 'c€/Wc', type: 'nombre', echelle: 100 },
        { cle: 'ict.electriciteEurParWc', titre: "Prix d'achat ICT", unite: 'c€/Wc', type: 'nombre', echelle: 100 },
      ]
    },
    colBatteriesPro() {
      return [
        VISIBLE,
        { ...FABRICANT, cle: 'marqueOnduleur' },
        { ...MODELE, cle: 'nom' },
        { cle: 'prixUnite', cles: ['prixBloc', 'prix'], titre: 'Bloc / unité', groupe: "Prix d'achat (€)", type: 'nombre', siPresent: true },
        { cle: 'prixMaitre', titre: 'Maître', groupe: "Prix d'achat (€)", type: 'nombre', siPresent: true },
        { cle: 'prixEsclave', titre: 'Esclave', groupe: "Prix d'achat (€)", type: 'nombre', siPresent: true },
        { ...RATIO_BATTERIE, formule: (r, l) => ratioExcel(r(l.prixEsclave != null ? 'prixEsclave' : 'prixUnite'), r('capacite'), 1, 0) },
        { cle: 'capacite', cles: ['kwhParModule', 'kwhParBloc', 'kwh'], titre: 'Capacité', unite: 'kWh', type: 'nombre' },
        { cle: 'charge', cles: ['chargeKwParModule', 'chargeKwParBloc', 'chargeKw'], titre: 'Charge', groupe: 'Puissance max (kW)', type: 'nombre' },
        { cle: 'decharge', cles: ['dechargeKwParModule', 'dechargeKwParBloc', 'dechargeKw'], titre: 'Décharge', groupe: 'Puissance max (kW)', type: 'nombre' },
      ]
    },
    colKits() {
      return [
        VISIBLE,
        FABRICANT,
        { ...MODELE, cle: 'nom' },
        { ...PRIX, titre: '€', unite: null, groupe: "Prix d'achat" },
        // ratios sur le prix du kit complet, pour information (30/10/2026)
        { cle: '_eurParKwh', titre: '€/kWh', groupe: "Prix d'achat", type: 'calcule', decimales: 0, valeur: l => (l.kwh > 0 && l.prix != null ? l.prix / l.kwh : null), formule: r => ratioExcel(r('prix'), r('kwh'), 1, 0) },
        { cle: '_eurParKva', titre: 'c€/VA', groupe: "Prix d'achat", type: 'calcule', decimales: 1, valeur: l => (l.kva > 0 && l.prix != null ? l.prix / l.kva / 10 : null), formule: r => ratioExcel(r('prix'), r('kva'), 0.1, 1) },
        { cle: 'kva', titre: 'Puissance AC max', unite: 'kVA', type: 'nombre' },
        { cle: 'kwh', titre: 'Capacité', unite: 'kWh', type: 'nombre' },
        { cle: 'chargeKw', titre: 'Charge', groupe: 'Batterie (kW)', type: 'nombre' },
        { cle: 'dechargeKw', titre: 'Décharge', groupe: 'Batterie (kW)', type: 'nombre' },
        { cle: 'veilleW', titre: 'Veille', unite: 'W', type: 'nombre' },
      ]
    },
    colCables() {
      return [
        { cle: 'ref', titre: 'Référence', largeur: '300px' },
        { cle: 'prix', titre: "Prix d'achat", unite: '€/m', type: 'nombre' },
        { cle: 'ame', titre: 'Âme', type: 'choix', options: AMES },
        { cle: 'section', titre: 'Section', unite: 'mm²', type: 'nombre' },
      ]
    },
    colLimitesPuissance() {
      return [
        { cle: 'kwcMaxParticulier', titre: "Particulier : jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'kwcMinPro', titre: 'Professionnel : à partir de', unite: 'kWc', type: 'nombre' },
      ]
    },
    colDatalogger() {
      return [
        { cle: 'kvaMax', titre: "Jusqu'à", unite: 'kVA', type: 'nombre' },
        { cle: 'prix', titre: 'Prix de vente', unite: '€', type: 'nombre', signalerVide: true },
      ]
    },
    colHausseMaintenance() {
      return [
        { cle: 'hausseMaintenancePct', titre: 'Hausse de la maintenance', unite: '%', type: 'nombre' },
        { cle: 'hausseMaintenancePeriode', titre: 'tous les', unite: 'ans', type: 'nombre' },
      ]
    },
    colDefauts() {
      return [
        { cle: '_quoi', titre: 'Réglage', type: 'lecture' },
        { cle: 'valeur', titre: 'Valeur', type: 'nombre' },
        { cle: '_unite', titre: 'Unité', type: 'lecture' },
      ]
    },
    maintenanceModifiee() {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      const d = this.contenu.defautsEtudes, o = d && d.__orig
      return !!o && (o.hausseMaintenancePct !== d.hausseMaintenancePct || o.hausseMaintenancePeriode !== d.hausseMaintenancePeriode)
    },
    colRatios() {
      return [
        { cle: '_quoi', titre: 'Onduleur', type: 'lecture' },
        { cle: 'defaut', titre: 'Défaut', type: 'nombre', groupe: 'Ratio panneaux / onduleur' },
        { cle: 'max', titre: 'Max avant validation BE', type: 'nombre', groupe: 'Ratio panneaux / onduleur' },
      ]
    },
    colTarifs() {
      return [
        { cle: 'client', titre: 'Client', type: 'lecture', options: CLIENTS },
        { cle: 'tarifJour', titre: 'Par jour', unite: '€', type: 'nombre', groupe: 'Tarif par personne' },
        { cle: 'tarifNuit', titre: 'Par nuit', unite: '€', type: 'nombre', groupe: 'Tarif par personne' },
        { cle: 'poseurs', titre: 'Poseurs', type: 'nombre', groupe: 'Équipe' },
        { cle: 'electriciens', titre: 'Électriciens', type: 'nombre', groupe: 'Équipe' },
      ]
    },
    colMaterielElec() {
      return [
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'agri.electriciteEurParWc', titre: 'Agricole', unite: 'c€/Wc', type: 'nombre', echelle: 100, groupe: "Prix d'achat" },
        { cle: 'ict.electriciteEurParWc', titre: 'ICT', unite: 'c€/Wc', type: 'nombre', echelle: 100, groupe: "Prix d'achat" },
      ]
    },
    nbMaterielElec() {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      return (this.plates.tranches || []).reduce((m, l) => m + (l.aVerifier || []).filter(v => v.endsWith('electriciteEurParWc')).length, 0)
    },
  },
  async mounted() {
    await this.charger()
  },
  beforeRouteLeave(to, from, next) {
    if (this.estModifie && !window.confirm('Des modifications du catalogue ne sont pas enregistrées. Quitter quand même ?')) {
      next(false)
      return
    }
    next()
  },
  methods: {
    nombreFr,
    // nombre d'engins par client (04/11/2026)
    colEnginsClient(groupe) {
      return [
        { cle: 'client', titre: 'Client', type: 'lecture', options: CLIENTS },
        { cle: 'toiture', titre: 'Toiture', type: 'nombre', groupe },
        { cle: 'sol', titre: 'Centrale au sol', type: 'nombre', groupe },
        { cle: 'ombriere', titre: 'Ombrière', type: 'nombre', groupe, inactif: OMBRIERE_SANS_OBJET },
        { cle: 'carport', titre: 'Carport', type: 'nombre', groupe, inactif: CARPORT_SANS_OBJET },
      ]
    },
    colForfait(titre) {
      return [
        { cle: 'kwcMax', titre: "Jusqu'à", unite: 'kWc', type: 'nombre' },
        { cle: 'montant', titre, unite: '€/an', type: 'nombre' },
      ]
    },
    nb(lignes) {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      return lignes.reduce((n, l) => n + (l && Array.isArray(l.aVerifier) ? l.aVerifier.length : 0), 0)
    },
    nbOnglet(cle) {
      // eslint-disable-next-line no-unused-expressions
      this.revision
      if (!this.contenu) return 0
      const c = this.contenu
      const de = (partie, cles) => cles.reduce((n, k) => n + compter(partie[k]), 0)
      const OPEX = ['maintenance', 'assurance']
      const marges = c.marges || {}
      if (cle === 'particulier') return compter(c.particulier) - de(c.particulier, OPEX)
      if (cle === 'pro') return compter(c.pro) - de(c.pro, OPEX.concat(['prestations']))
      if (cle === 'marges') return compter(marges)
      if (cle === 'prestations') return compter(c.pro.prestations)
      if (cle === 'mainOeuvre') return compter(c.equipes) + compter(c.joursTravail) + compter(c.engins)
      if (cle === 'opex') return de(c.particulier, OPEX) + de(c.pro, OPEX)
      if (cle === 'general') return compter(c.ratios)
      return 0
    },
    nomFixation(i) { return i.marque ? i.marque + ' ' + i.ref : i.ref },
    nouveauPanneau() {
      return { marque: '', ref: '', wc: null, m2: null, longueur: null, largeur: null, prix: null, tva55: false,
        garantiePerformancePct: null, garantiePerformanceAns: null, garantieMaterielleAns: null }
    },
    nouvelleFixation(particulier) {
      return { marque: '', ref: '', eurParWc: null, typologies: ['inclinee'] }
    },
    colFixations(partie, particulier) {
      const cols = [VISIBLE, FABRICANT, MODELE, { cle: 'eurParWc', titre: "Prix d'achat", unite: 'c€/Wc', type: 'nombre', echelle: 100, signalerVide: true },
      ].concat((particulier ? TYPOLOGIES_PART : TYPOLOGIES_PRO).map(o => ({ cle: 'typologies:' + o.valeur, champ: 'typologies', valeur: o.valeur,
        ordre: (particulier ? TYPOLOGIES_PART : TYPOLOGIES_PRO).map(x => x.valeur), titre: o.libelle.charAt(0).toUpperCase() + o.libelle.slice(1),
        type: 'caseListe', groupe: 'Typologies de toiture' })))
      if (particulier) {
        // cases du carport grisées quand la typologie « carport » n'est pas cochée (03/11/2026)
        const pasCarport = l => !(l.typologies || []).includes('carport')
        cols.push({ cle: 'panneau', titre: 'Modèle', type: 'choix', style: { fontSize: '12px', maxWidth: '200px' }, groupe: 'Panneaux du carport', inactif: pasCarport,
          options: [{ valeur: null, libelle: '—' }].concat(partie.panneaux.map(p => ({ valeur: (p.marque ? p.marque + ' ' : '') + p.ref, libelle: (p.marque ? p.marque + ' ' : '') + p.ref }))) })
        cols.push({ cle: 'panneauxParUnite', titre: 'Nombre par carport', type: 'nombre', groupe: 'Panneaux du carport', inactif: pasCarport })
      } else {
        cols.push({ cle: 'filetsSousToiture', titre: 'Filet sous toiture', type: 'case' })
      }
      return cols
    },
    bornes(partie) {
      if (!partie.bornes) this.$set(partie, 'bornes', [])
      return partie.bornes
    },
    shelter() {
      if (!this.contenu.pro.shelter) this.$set(this.contenu.pro, 'shelter', [])
      return this.contenu.pro.shelter
    },
    onduleurs(partie, hybride) {
      return partie.onduleurs.filter(o => !!o.hybride === hybride)
    },
    nouvelOnduleur(phase, marque, hybride) {
      return hybride ? { marque, ref: '', phase, hybride, kva: null, prix: null, veilleW: null, batterieChargeKw: null, batterieDechargeKw: null }
        : { marque, ref: '', phase, hybride, kva: null, prix: null, veilleW: null }
    },
    modifie() { this.revision++ },
    /** Tableaux de la page exportés en Excel (une feuille chacun) et relus à l'import (03/11/2026). */
    tablesExcel() {
      const c = this.contenu, p = c.particulier, pro = c.pro
      const t = []
      const titreOnglet = cle => (this.onglets.find(o => o.cle === cle) || {}).titre
      let onglet = ''
      const ajouter = (titre, lignes, colonnes, options) => t.push({ onglet, titre, lignes, colonnes, ...(options || {}) })
      const lecteur = x => () => x
      const tranche = { kwcMax: null, pv: null, batterie: null, presta: null, bornes: null }
      const prixWc = { kwcMax: null, eurParWc: null }
      const hybride = o => !!o.hybride === true
      const reseau = o => !!o.hybride === false
      // CAPEX Particulier (mêmes tableaux, même ordre que la page)
      onglet = titreOnglet('particulier')
      ajouter('Panneaux', () => p.panneaux, this.colPanneaux, { modele: this.nouveauPanneau() })
      ajouter("Systèmes d'intégration", () => p.integrations, this.colFixations(p, true), { modele: this.nouvelleFixation(true) })
      ajouter('Onduleurs hybrides', () => p.onduleurs, this.colOnduleursHybrides, { filtre: hybride, modele: this.nouvelOnduleur('mono', 'HUAWEI', true) })
      ajouter('Bornes de charge', () => this.bornes(p), this.colBornes, { modele: { marque: '', ref: '', prix: null } })
      ajouter('Batteries', () => p.batteries, this.colBatteriesPart, { modele: { marque: 'HUAWEI', ref: '', prix: null, kwh: null, chargeKw: null, dechargeKw: null } })
      ajouter('Optimiseurs', () => p.optimiseurs, this.colOptimiseur, { modele: { marque: '', ref: '', prixParPanneau: null } })
      ajouter('Backup', () => p.backups, this.colBackupPart, { modele: { marque: '', ref: '', prix: null, raccordement: 'mono' } })
      ajouter('Matériel électrique', () => p.electricite, this.colPrixWc, { modele: prixWc })
      // CAPEX Professionnel
      onglet = titreOnglet('pro')
      ajouter('Panneaux', () => pro.panneaux, this.colPanneaux, { modele: this.nouveauPanneau() })
      ajouter("Systèmes d'intégration", () => pro.integrations, this.colFixations(pro, false), { modele: this.nouvelleFixation(false) })
      ajouter('Onduleurs réseau', () => pro.onduleurs, this.colOnduleursPro, { filtre: reseau, modele: this.nouvelOnduleur('tri', 'FOX ESS', false) })
      ajouter('Onduleurs hybrides', () => pro.onduleurs, this.colOnduleursHybridesPro, { filtre: hybride, modele: this.nouvelOnduleur('tri', 'FOX ESS', true) })
      if (pro.kits) ajouter('Kits Onduleurs hybrides + Batteries', () => pro.kits, this.colKits, { modele: { marque: 'FOX ESS', nom: '', prix: null, kva: null, kwh: null, chargeKw: null, dechargeKw: null, veilleW: null } })
      ajouter('Batteries', () => this.batteriesPro, this.colBatteriesPro, { fixe: true })
      if (pro.batteriesCq7) ajouter('Règles — CQ7', lecteur([pro.batteriesCq7]), this.colRegleCq7, { fixe: true })
      if (pro.batteriesPowerKeeper) {
        ajouter('Règles — PowerKeeper : configurations', () => pro.batteriesPowerKeeper.configurations, this.colConfigPowerKeeper, { modele: { blocs: null, piles: null } })
        ajouter('Règles — PowerKeeper : tension', lecteur([pro.batteriesPowerKeeper]), [{ cle: 'tensionBlocV', titre: 'Tension par bloc', unite: 'V', type: 'nombre' }], { fixe: true })
      }
      if (pro.powerstack) ajouter('Règles — Powerstack', lecteur([pro.powerstack]), this.colReglePowerstack, { fixe: true })
      if (pro.kits) ajouter('Règles — Kits', lecteur([pro]), [{ cle: 'kitsMax', titre: 'Nombre maximum de kits', type: 'nombre' }], { fixe: true })
      ajouter('Backup', () => pro.backups, this.colBackupPro, { modele: { marque: '', ref: '', prix: null, kva: null } })
      ajouter('Shelter', () => this.shelter(), this.colShelter, { modele: { marque: '', ref: '', prix: null, onduleursMax: null } })
      ajouter('Bornes de charge', () => this.bornes(pro), this.colBornes, { modele: { marque: '', ref: '', prix: null } })
      if (pro.datalogger) ajouter('Datalogger', () => pro.datalogger, this.colDatalogger, { modele: { kvaMax: null, prix: null } })
      ajouter('Matériel électrique', () => this.plates.tranches || [], this.colMaterielElec, { fixe: true })
      if (pro.cables) {
        const cable = categorie => ({ ref: '', prix: null, categorie, ame: 'alu', section: null, phase: 'tri' })
        ajouter('Câble Onduleur ↔ TGBT — Standard', () => pro.cables, this.colCables, { filtre: x => x.categorie !== 'erp', modele: cable('standard') })
        ajouter('Câble Onduleur ↔ TGBT — ERP', () => pro.cables, this.colCables, { filtre: x => x.categorie === 'erp', modele: cable('erp') })
      }
      if (pro.abaqueCable) ajouter('Abaque des sections (mm², câble aluminium)', () => pro.abaqueCable, this.colAbaque, { fixe: true })
      // Marges
      if (c.marges) {
        onglet = titreOnglet('marges')
        this.tableauxMarges.forEach(x => ajouter(x.titre, () => x.lignes, this.colMargesSections, { modele: tranche }))
      }
      // Prestations
      if (pro.prestations) {
        onglet = titreOnglet('prestations')
        ajouter('Ombrières : structure primaire', () => pro.prestations.ombriereStructure, this.colPrixWc, { modele: prixWc })
        ajouter('Ombrières : pose sous-traitée', () => pro.prestations.ombrierePose, this.colPrixWc, { modele: prixWc })
        ajouter('Pose de filets sous toiture', () => pro.prestations.filets, this.colPrixWc, { modele: prixWc })
        ajouter('Pose de bac acier', () => pro.prestations.bacAcier, this.colPrixM2, { modele: { m2Max: null, eurParM2: null } })
      }
      // Main d'œuvre
      onglet = titreOnglet('mainOeuvre')
      if (c.equipes) ajouter('Équipes', () => c.equipes, this.colTarifs, { fixe: true })
      this.tableauxJours.forEach(x => ajouter(x.titre, () => x.lignes, this.colJoursClient, { modele: { client: 'agri', kwcMax: null, toiture: null, sol: null, ombriere: null, carport: null } }))
      if (c.engins) {
        ajouter('Prix des engins', lecteur([c.engins]), this.colPrixEngins, { fixe: true })
        this.tableauxEngins.forEach(x => ajouter(x.titre, () => x.lignes, this.colEnginsClient(x.groupe), { fixe: true }))
      }
      // OPEX
      onglet = titreOnglet('opex')
      ajouter('Maintenance Particulier', () => p.maintenance || [], this.colForfait('Maintenance'), { modele: { kwcMax: null, montant: null } })
      ajouter('Assurance Particulier', () => p.assurance || [], this.colForfait('Assurance'), { modele: { kwcMax: null, montant: null } })
      ajouter('Maintenance Professionnel', () => pro.maintenance || [], this.colMaintenance, { modele: { kwcMax: null, agri: null, ict: null } })
      ajouter('Assurance Professionnel', () => pro.assurance || [], this.colAssurancePro, { modele: { kwcMax: null, montant: null } })
      // Hypothèses : tous les tableaux de l'onglet (04/11/2026)
      onglet = titreOnglet('general')
      if (c.limites) ajouter('Limites de puissance des études', lecteur([c.limites]), this.colLimitesPuissance, { fixe: true })
      ajouter('Ratio panneaux / onduleur', () => this.ratiosPlats, this.colRatios, { fixe: true })
      if (c.defautsEtudes) {
        this.groupesDefauts.forEach(g => ajouter('Hypothèses de calcul — ' + g.groupe, () => g.lignes, this.colDefauts, { fixe: true }))
        ajouter('Hypothèses de calcul — OPEX', lecteur([c.defautsEtudes]), this.colHausseMaintenance, { fixe: true })
        ajouter("Hypothèses de calcul — Inflation de l'assurance", () => this.ligneAssurance, this.colDefauts, { fixe: true })
      }
      return t
    },
    async exporterExcel() {
      this.excelEnCours = true
      try {
        await exporterCatalogue(this.tablesExcel(), 'catalogue-retix-version-' + (this.version || '') + '.xlsx')
      } catch (e) {
        this.$toasted && this.$toasted.error("L'export Excel a échoué.")
      } finally {
        this.excelEnCours = false
      }
    },
    async importerExcel(e) {
      const fichier = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!fichier) return
      this.excelEnCours = true
      this.compteRenduExcel = ''
      try {
        const cr = await importerCatalogue(await fichier.arrayBuffer(), this.tablesExcel(), (o, k, v) => this.$set(o, k, v))
        // tableaux à plat (tranches pro, engins, ratios) : recopiés dans le catalogue
        if (this.plates.tranches) this.modifieTypologie('tranches')
        this.modifieRatios()
        if (this.contenu.defautsEtudes) this.modifieDefauts()
        this.modifie()
        this.compteRenduExcel = 'Fichier « ' + fichier.name + ' » lu : ' + cr.valeurs + ' valeur' + (cr.valeurs > 1 ? 's' : '') + ' modifiée' + (cr.valeurs > 1 ? 's' : '')
          + (cr.lignesAjoutees ? ', ' + cr.lignesAjoutees + ' ligne(s) ajoutée(s)' : '') + (cr.lignesRetirees ? ', ' + cr.lignesRetirees + ' ligne(s) retirée(s)' : '')
          + (cr.ignorees.length ? ' ; feuilles ignorées : ' + cr.ignorees.join(', ') : '') + '. Vérifiez les changements puis enregistrez.'
      } catch (err) {
        this.compteRenduExcel = 'Le fichier Excel n\'a pas pu être lu : utilisez un fichier exporté depuis cette page.'
      } finally {
        this.excelEnCours = false
      }
    },
    // tranches pro : colonnes « agri.x » / « ict.x » à plat pour le tableau, recopiées dans le catalogue à chaque saisie
    // ratios (29/10/2026) : lignes réseau et hybride, colonnes défaut et max (au-delà, à valider avec le BE)
    aplatirRatios() {
      const r = this.contenu.ratios || {}
      this.ratiosPlats = [
        { _quoi: 'Onduleur réseau', defaut: r.reseau, max: r.reseauMaxBe, _cles: ['reseau', 'reseauMaxBe'] },
        { _quoi: 'Onduleur hybride', defaut: r.hybride, max: r.hybrideMaxBe, _cles: ['hybride', 'hybrideMaxBe'] },
      ]
    },
    // valeurs par défaut des nouvelles études affichées (02/11/2026) : une ligne par réglage, recopiée dans le catalogue
    // à chaque saisie ; OPEX : hausse de la maintenance sur une ligne à part, puis l'inflation de l'assurance
    aplatirDefauts() {
      const d = this.contenu.defautsEtudes || {}
      const ligne = cle => {
        const p = PARAMETRES_ETUDE.find(x => x.cle === cle)
        return { _cle: cle, _quoi: p.libelle, _unite: p.unite || '', valeur: d[cle] }
      }
      this.groupesDefauts = DEFAUTS_AFFICHES.map(g => ({ groupe: g.groupe, lignes: g.cles.map(ligne) }))
      this.ligneAssurance = [ligne('inflationAssurance')]
    },
    modifieDefauts() {
      this.groupesDefauts.concat([{ lignes: this.ligneAssurance }])
        .forEach(g => g.lignes.forEach(l => this.$set(this.contenu.defautsEtudes, l._cle, l.valeur)))
      this.modifie()
    },
    ecrireDefaut(cle, texte) {
      this.$set(this.contenu.defautsEtudes, cle, texte === '' ? null : Number(texte))
      this.modifie()
    },
    modifieRatios() {
      if (!this.contenu.ratios) this.$set(this.contenu, 'ratios', {})
      this.ratiosPlats.forEach(l => {
        this.$set(this.contenu.ratios, l._cles[0], l.defaut)
        this.$set(this.contenu.ratios, l._cles[1], l.max)
      })
      this.modifie()
    },
    // tranches pro de chaque typologie à plat (« agri.joursPose »…), valeurs à vérifier comprises (« agri.x »)
    aplatirTypologies() {
      const plates = {}
      ;['tranches'].forEach(cle => {
        plates[cle] = (this.contenu.pro[cle] || []).map(x => {
          const l = { kwcMax: x.kwcMax }
          const av = (x.aVerifier || []).slice()
          ;['agri', 'ict'].forEach(k => Object.keys(x[k] || {}).forEach(c => {
            if (c === 'aVerifier') x[k][c].forEach(v => av.push(k + '.' + v))
            else l[k + '.' + c] = x[k][c]
          }))
          if (av.length) l.aVerifier = av
          return l
        })
      })
      this.plates = plates
      this.tranchesPlates = plates.tranches || []
    },
    modifieTypologie(cle) {
      this.plates[cle].forEach((l, i) => {
        const t = this.contenu.pro[cle][i]
        t.kwcMax = l.kwcMax
        Object.keys(l).filter(c => c.includes('.')).forEach(c => {
          const [k, champ] = c.split('.')
          this.$set(t[k], champ, l[c])
        })
        // valeurs validées (✓ ou saisie) : retirées des « à vérifier » de la tranche
        const av = l.aVerifier || []
        if (av.some(v => !v.includes('.'))) this.$set(t, 'aVerifier', av.filter(v => !v.includes('.'))); else this.$delete(t, 'aVerifier')
        ;['agri', 'ict'].forEach(k => {
          const reste = av.filter(v => v.startsWith(k + '.')).map(v => v.slice(k.length + 1))
          if (reste.length) this.$set(t[k], 'aVerifier', reste); else if (t[k]) this.$delete(t[k], 'aVerifier')
        })
      })
      this.modifie()
    },
    modifieTranches() { this.modifieTypologie('tranches') },
    // les libellés « _quoi » des tableaux regroupés ne sont pas enregistrés
    nettoye(objet) {
      return JSON.parse(JSON.stringify(objet, (k, v) => (k.startsWith('_') ? undefined : v)))
    },
    marquer() {
      marquerOrigine(this.contenu)
      Object.keys(this.plates).forEach(k => marquerOrigine(this.plates[k]))
      marquerOrigine(this.ratiosPlats)
      this.groupesDefauts.forEach(g => marquerOrigine(g.lignes))
      marquerOrigine(this.ligneAssurance)
    },
    async basculerChangements(v, precedente) {
      const actuel = this.changements[v.id]
      if (actuel) { actuel.ouvert = !actuel.ouvert; return }
      this.$set(this.changements, v.id, { ouvert: true, chargement: true, lignes: [], tout: false })
      try {
        const [a, b] = await Promise.all([precedente.id, v.id].map(id =>
          axios.get(conf.API_URL + '/catalogue-materiel/versions/' + id, entetes()).then(r => r.data.data)))
        this.changements[v.id].lignes = changementsCatalogue(a, b)
      } catch (e) {
        this.changements[v.id].lignes = ['Comparaison impossible : réessayez dans un instant.']
      } finally {
        this.changements[v.id].chargement = false
      }
    },
    async charger() {
      this.chargement = true
      this.erreurChargement = ''
      try {
        const [actif, versions] = await Promise.all([
          axios.get(conf.API_URL + '/catalogue-materiel', entetes()),
          axios.get(conf.API_URL + '/catalogue-materiel/versions', entetes()),
        ])
        this.version = actif.data.data.version
        this.contenu = this.nettoye(actif.data.data.contenu)
        this.aplatirTypologies()
        this.aplatirRatios()
        this.aplatirDefauts()
        this.original = JSON.stringify(this.contenu)
        this.marquer()
        this.historique = versions.data.data
        this.changements = {}
      } catch (e) {
        this.erreurChargement = e.response && e.response.status === 403
          ? 'Accès réservé aux administrateurs.'
          : 'Catalogue indisponible : réessayez dans un instant.'
      } finally {
        this.chargement = false
      }
    },
    annuler() {
      this.contenu = JSON.parse(this.original)
      this.aplatirTypologies()
      this.aplatirRatios()
      this.aplatirDefauts()
      this.marquer()
      this.erreurs = []
      this.revision++
    },
    async enregistrer() {
      this.enregistrement = true
      this.erreurs = []
      try {
        await axios.put(conf.API_URL + '/catalogue-materiel', { contenu: this.nettoye(this.contenu), commentaire: this.commentaire }, entetes())
        this.commentaire = ''
        this.$toasted && this.$toasted.success('Catalogue enregistré.')
        await this.charger()
      } catch (e) {
        const d = e.response && e.response.data
        this.erreurs = (d && d.data && d.data.erreurs) || [(d && d.message) || "L'enregistrement a échoué."]
      } finally {
        this.enregistrement = false
      }
    },
    async restaurer(v) {
      if (this.estModifie && !window.confirm('Les modifications non enregistrées seront perdues. Continuer ?')) return
      if (!window.confirm('Rétablir la version n° ' + v.id + ' (' + v.commentaire + ') ? Elle deviendra la version active.')) return
      try {
        await axios.post(conf.API_URL + '/catalogue-materiel/versions/' + v.id + '/restaurer', {}, entetes())
        this.$toasted && this.$toasted.success('Version n° ' + v.id + ' rétablie.')
        await this.charger()
        this.onglet = 'historique'
      } catch (e) {
        const d = e.response && e.response.data
        this.$toasted && this.$toasted.error((d && d.message) || 'Le retour à cette version a échoué.')
      }
    },
    dateFr(d) {
      if (!d) return ''
      const x = new Date(d)
      return x.toLocaleDateString('fr-FR') + ' ' + x.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    },
  },
}
</script>

<style scoped>
.catalogue-entete { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 18px; }
.page-titre { font-size: 26px; font-weight: 800; color: #1a1a2e; margin: 0; }
.page-sous-titre { margin: 4px 0 0; font-size: 14px; color: #888; }
.catalogue-note { color: #666; }
.consultation { color: #1565c0; font-weight: 600; }
/* liste encore vide (03/11/2026) : même jaune que les valeurs à vérifier */
.a-completer { display: inline-block; background: #fff6bf; border: 1px solid #d9a400; border-radius: 4px; padding: 4px 8px; font-size: 13px; margin: 0 0 8px; }
.catalogue-erreur { color: #c62828; font-weight: 600; }
.historique-actions { white-space: nowrap; display: flex; gap: 6px; }
.changements td { background: #fafbfc; }
.changements ul { margin: 4px 0 8px; padding-left: 20px; font-size: 13px; color: #3a3f4b; }
.changements-titre { margin: 0; font-size: 13px; font-weight: 600; color: #1a1a2e; }
.onglets { display: flex; gap: 6px; margin-bottom: 12px; flex-wrap: wrap; }
.onglet { padding: 8px 16px; border: 1px solid #d5d9e0; border-radius: 18px; background: #fff; color: #3a3f4b; font-weight: 600; font-size: 14px; cursor: pointer; }
.onglet--actif { background: #1a1a2e; border-color: #1a1a2e; color: #fff; }
section { margin-bottom: 26px; }
h2 { font-size: 17px; font-weight: 700; color: #1a1a2e; margin: 0 0 6px; text-align: left; }
h4 { font-size: 13px; font-weight: 600; color: #555; margin: 6px 0 2px; text-align: left; }
h3 { font-size: 14px; font-weight: 700; color: #3a3f4b; margin: 12px 0 4px; text-align: left; }
.regles ul { margin: 2px 0 6px; padding-left: 20px; font-size: 13px; color: #3a3f4b; }
.regles li { margin: 2px 0; }
.avertissement { font-size: 12px; color: #8a5300; margin: 2px 0 6px; }
.aide { font-size: 12px; color: #555; margin: 0 0 6px; }
.legende-verifier { display: flex; align-items: center; gap: 8px; margin: 0 0 10px; font-size: 13px; color: #6b5300; }
.case-exemple { display: inline-block; width: 22px; height: 14px; background: #fff6bf; border: 1px solid #d9a400; border-radius: 3px; }
.badge-verifier { margin-left: 6px; padding: 0 7px; border-radius: 9px; background: #fff6bf; color: #6b5300; font-size: 12px; border: 1px solid #d9a400; }
.cote-a-cote { display: flex; flex-wrap: wrap; gap: 32px; align-items: flex-start; }
.cote-a-cote--serre { gap: 12px; }
.ligne-maintenance { font-size: 13px; color: #3a3f4b; margin: 4px 0 8px; }
.ligne-maintenance input { width: 64px; padding: 4px 6px; border: 1px solid #d5d9e0; border-radius: 4px; font-size: 13px; text-align: right; }
.ligne-maintenance.modifiee input { border-color: #1e88e5; box-shadow: 0 0 0 1px #1e88e5 inset; }
.historique { width: 100%; border-collapse: collapse; font-size: 14px; }
.historique th { text-align: left; padding: 8px 6px; border-bottom: 2px solid #e8eaee; color: #555; }
.historique td { padding: 8px 6px; border-bottom: 1px solid #f0f1f4; }
.badge-active { margin-left: 8px; padding: 2px 8px; border-radius: 10px; background: #e8f5e9; color: #2e7d32; font-size: 12px; font-weight: 700; }
.barre-enregistrement { position: sticky; bottom: 0; background: #fff; border-top: 1px solid #e8eaee; padding: 12px 0 6px; margin-top: 12px; z-index: 2; }
.barre-ligne { display: flex; gap: 10px; align-items: center; }
.actions-excel { display: flex; gap: 8px; align-items: center; }
.actions-excel .btn-ligne { margin: 0; line-height: 1.5; }
.btn-import-excel { position: relative; cursor: pointer; margin: 0; }
.btn-import-excel.desactive { opacity: .5; pointer-events: none; }
.fichier-excel { position: absolute; inset: 0; opacity: 0; cursor: pointer; width: 100%; }
.compte-rendu-excel { font-size: 13px; color: #1565c0; margin: 0 0 6px; }
.changements-en-cours { font-size: 12px; color: #333; margin: 0 0 8px; max-height: 160px; overflow: auto; }
.changements-en-cours__titre { font-weight: 700; }
.changements-en-cours ul { margin: 2px 0 0; padding-left: 18px; }
.lien { border: none; background: none; color: #1565c0; text-decoration: underline; cursor: pointer; font-size: 12px; padding: 0; }
.commentaire { flex: 1; padding: 8px 12px; border: 1px solid #d5d9e0; border-radius: 18px; font-size: 14px; }
.catalogue-erreurs { margin: 0 0 8px; padding: 8px 12px 8px 28px; background: #fdecea; border-radius: 6px; color: #c62828; font-size: 13px; }
.btn-jaune { display: inline-block; padding: 9px 22px; border: none; border-radius: 22px; background: #f5c518; color: #1a1a2e; font-weight: 700; font-size: 14px; cursor: pointer; }
.btn-jaune:disabled, .btn-ligne:disabled { opacity: 0.5; cursor: not-allowed; }
.btn-ligne { display: inline-block; padding: 6px 14px; border: 1px solid #d5d9e0; border-radius: 16px; background: #fff; color: #3a3f4b; font-size: 13px; font-weight: 600; cursor: pointer; }
</style>
